import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'fr-CA',
  months: [
    'janvier',
    'février',
    'mars',
    'avril',
    'mai',
    'juin',
    'juillet',
    'août',
    'septembre',
    'octobre',
    'novembre',
    'décembre',
  ],
  monthsShort: ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juill.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
  weekdays: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
  weekdaysMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
  weekdaysShort: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
  formats: {
    LT: 'HH [h] mm',
    LTS: 'HH [h] mm [min] ss [s]',
    lt: 'h [h] mm A',
    lts: 'h [h] mm [min] ss [s] A',
    L: 'YYYY-MM-DD',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY, HH [h] mm',
    'LLL-Y': 'D MMMM, HH [h] mm',
    LLLL: 'dddd D MMMM YYYY, HH [h] mm',
    'LLLL-Y': 'dddd D MMMM, HH [h] mm',
    l: 'YYYY-MM-DD',
    'l-Y': 'M-D',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY, h [h] mm A',
    'lll-Y': 'D MMM, h [h] mm A',
    llll: 'ddd D MMM YYYY, h [h] mm A',
    'llll-Y': 'ddd D MMM, h [h] mm A',
    'll-Y+w': 'ddd D MMM',
    'LT+to': 'HH [h] mm ([UTC]Z)',
    'LLL+to': 'D MMMM YYYY, HH [h] mm ([UTC]Z)',
  },
  meridiem: { am: 'a.m.', pm: 'p.m.', AM: 'a.m.', PM: 'p.m.' },
  past: {
    y: { one: 'il y a %s a', other: 'il y a %s a' },
    M: { one: 'il y a %s m.', other: 'il y a %s m.' },
    w: { one: 'il y a %s sem.', other: 'il y a %s sem.' },
    d: { one: 'il y a %s j', other: 'il y a %s j' },
    h: { one: 'il y a %s h', other: 'il y a %s h' },
    m: { one: 'il y a %s min', other: 'il y a %s min' },
    s: { one: 'il y a %s s', other: 'il y a %s s' },
  },
  future: {
    y: { one: 'dans %s a', other: 'dans %s a' },
    M: { one: 'dans %s m.', other: 'dans %s m.' },
    w: { one: 'dans %s sem.', other: 'dans %s sem.' },
    d: { one: 'dans %s j', other: 'dans %s j' },
    h: { one: 'dans %s h', other: 'dans %s h' },
    m: { one: 'dans %s min', other: 'dans %s min' },
    s: { one: 'dans %s s', other: 'dans %s s' },
  },
  abbr: {
    y: { one: '%s an', other: '%s ans' },
    M: { one: '%s m.', other: '%s m.' },
    w: { one: '%s sem.', other: '%s sem.' },
    d: { one: '%s j', other: '%s j' },
    h: { one: '%s h', other: '%s h' },
    m: { one: '%s min', other: '%s min' },
    s: { one: '%s s', other: '%s s' },
  },
  justNow: 'maintenant',
  yesterday: 'hier',
  today: 'aujourd’hui',
  tomorrow: 'demain',
  weekStart: 0,
};
const localeName: LocaleName = 'fr-CA';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'a.m.' : 'a.m.';
    } else {
      return isLowerCase ? 'p.m.' : 'p.m.';
    }
  },
};
